// extracted by mini-css-extract-plugin
export default {"block_left_03":"index_block_left_03_HnZBJ","dl_list_01":"index_dl_list_01_04DGL","text":"index_text_HQG-x","links":"index_links_qIEm-"};